import { createVanIconComponent } from "./van"

const DesktopOutlined = createVanIconComponent("desktop-o")
export default DesktopOutlined
